import { mdiFileExcelOutline, mdiPlus } from "@mdi/js";
import { Button, Space } from "antd";
import { MaterialIcon } from "components/MaterialIcon";
import { Permission } from "components/Permission";
import React from "react";
import { useTranslation } from "react-i18next";

interface TableHeaderOptionsProps {
  onNewButtonClick?: React.MouseEventHandler<HTMLElement>;
  onExportButtonClick?: React.MouseEventHandler<HTMLElement>;
  exportLoading?: boolean;
  exportClaims?: string[];
  addNewClaims?: string[];
}

const TableHeaderOptions: React.FC<TableHeaderOptionsProps> = ({
  onNewButtonClick,
  onExportButtonClick,
  exportLoading,
  exportClaims = [],
  addNewClaims = [],
}) => {
  const { t } = useTranslation();

  return (
    <Space>
      {onNewButtonClick && (
        <Permission acceptableClaims={addNewClaims}>
          <Button
            icon={<MaterialIcon path={mdiPlus} />}
            type="primary"
            onClick={onNewButtonClick}
          >
            {t("common.new")}
          </Button>
        </Permission>
      )}

      <Permission acceptableClaims={exportClaims}>
        <Button
          icon={<MaterialIcon path={mdiFileExcelOutline} />}
          onClick={onExportButtonClick}
          loading={exportLoading}
        >
          {t("common.export")}
        </Button>
      </Permission>
    </Space>
  );
};

export default TableHeaderOptions;
